import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpRequest, HttpParams, HttpHeaders, HttpEvent } from '@angular/common/http';
import { AuthenticationService } from '../auth';
import { Globals } from '../globals';
import { Cookie } from 'ng2-cookies';
import { Observable } from 'rxjs';

@Injectable()
export class AdministrationService implements OnInit {

    constructor(private http: HttpClient, private authService: AuthenticationService, private globals: Globals) { }

    ngOnInit() : void {
        this.authService.isTokenValid();
    }

    /**
     * Add a new group entity
     * @param groupName inputform with data for the employer to be created
     */
    addGroup(groupName): Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/administration/group';

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
        .set('groupBody', JSON.stringify(groupName));

        return this.http.post(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Get all available groups
     * @returns list of groups
     */
    getAllGroups(): Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/administration/group';
        let requestHeaders = new HttpHeaders()
              .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());
  
          return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Deletes a group entity by its uuid
     * @param uuid uuid of group object
     */
    deleteGroup(uuid): Observable<any> {
        this.authService.isTokenValid();

        const url = this.authService.getResourceURL() + '/api/v1/administration/group/'+ uuid;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.delete(url, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Get all persons
     */
     getPersonsNotInGroup(groupId): Observable<any>{
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/person/group/notInGroup/' + groupId;
        let requestHeaders = new HttpHeaders()
              .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

          return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Add persons to group
     * @param group group object
     * @param addMembers list of persons to add
     * @returns updated group object
     */
    addGroupMembers(groupId, addMembers): Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/administration/group/'+groupId+'/member/add';

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
        .set('memberListBody', JSON.stringify(addMembers));

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Update existing group
     * @param group group object
     */
    updateGroup(groupId, groupName): Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/administration/group/' + groupId;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
        .set('groupNameBody', JSON.stringify(groupName));

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Remove persons from group
     * @param group group object
     * @param removeMembers list of persons to remove
     * @returns updated group object
     */
     removeGroupMembers(groupId, removeMembers): Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/administration/group/'+groupId+'/member/remove';

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
        .set('memberListBody', JSON.stringify(removeMembers));

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     *
     * @returns list of all read or standard users
     */
    getAllOwners(groupId): Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/user/group/' + groupId + '/missing';
        let requestHeaders = new HttpHeaders()
              .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

          return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Add owners to group
     * @param groupId group object
     * @param addOwners list of owners to add
     * @returns updated group object
     */
     addGroupOwners(groupId, addOwners): Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/administration/group/'+groupId+'/owner/add';

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()        
        .set('ownerListBody', JSON.stringify(addOwners));

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Remove owners from group
     * @param group group object
     * @param removeOwners list of owners to remove
     * @returns updated group object
     */
     removeGroupOwners(groupId, removeOwners): Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/administration/group/'+groupId+'/owner/remove';

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
        .set('ownerListBody', JSON.stringify(removeOwners));

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    getALLGroupMembers(): Observable<any>{
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/administration/group/members';

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }
}
